<template>
  <div class="filter-condition">
    <el-input
      class="filter-condition-input"
      v-model="state.searchValue"
      prefix-icon="el-icon-search"
      placeholder="Search"
      autocomplete="off"
      @keyup.enter.native="goGoodsSearch"
    />

    <!-- 分类筛选网格 -->
    <div
      class="cat-grid"
      v-if="menuList.length > 0 && menuList[0].menuName === undefined"
    >
      <div
        v-for="(item, index) in menuList"
        :key="item.categoryName"
        class="cat-card cat-card--in"
        :style="{ animationDelay: `${index * 0.06}s` }"
        @click="goCategory(item)"
      >
        <span class="cat-name">
          {{ item.categoryName }}
        </span>
        <el-image
          class="cat-img"
          :src="item.categoryCover"
          fit="contain"
        >
          <div
            slot="error"
            class="image-slot"
          >
          </div>
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FilterCondition',
  props: {
    // 首页菜单配置
    menuList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      state: {
        searchValue: ''
      }
    }
  },

  methods: {
    goGoodsSearch() {
      this.$router.push({
        path: '/goods',
        query: { keyword: this.state.searchValue }
      })
    },

    // 点击分类跳转商品列表
    goCategory(item) {
      this.$router.push({
        path: '/goods',
        query: { parentCateIds: item.id || '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.filter-condition {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 12px;
  padding: 0 0 16px;

  &-input :deep(.el-input__inner) {
    color: var(--select-color) !important;
    border: 1px solid hsl(from var(--select-border-color) h s l / 0.8) !important;
    background-color: hsl(from var(--select-border-color) h s l / 0.5);
    border-radius: 12px;
  }
}

/* 分类卡片淡入 */
@keyframes catFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 三列分类网格 */
.cat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 16px;
  background-color: var(--background-color);
}

.cat-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 100px;
  padding: 12px 14px;
  border-radius: 8px;
  background: hsl(from var(--select-border-color) h s l / 0.8);
  cursor: pointer;
  transition: background 0.18s ease;

  &--in {
    opacity: 0;
    animation: catFadeIn 0.4s ease forwards;
  }

  &:hover {
    background: hsl(from var(--select-border-color) h s l / 0.5);
  }
}

.cat-name {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  color: var(--primary-color);
  text-align: left;
  word-break: break-word;
}

.cat-img {
  flex-shrink: 0;
  width: 60px;
  height: 60px;

  :deep(.el-image__placeholder) {
    background-color: transparent;
  }
}

:deep(.image-slot) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 22px;
  color: var(--select-color);
  background-color: hsl(from var(--select-border-color) h s l / 0.8);
  /* ~@ 让 webpack 解析别名，纯 @/ 在 css url 里无效 */
  background-image: url(~@/assets/images/category-default.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .cat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
